export const scalars = ['string', 'boolean', 'integer', 'number'];
export function isScalar(str) {
    return Array.from(scalars).includes(str);
}
